import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ToastrService } from 'ngx-toastr';
import { Bank } from 'src/app/models/bank.model';
import { SchoolInformationview } from 'src/app/models/schoolinformationview.model';
import { Settings } from 'src/app/models/settings.model';
import { BillingAccountService } from 'src/app/services/BillingAccount/billing-account.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { PaymentService } from 'src/app/services/payment.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-accountsettings',
  templateUrl: './accountsettings.component.html',
  styleUrls: ['./accountsettings.component.css']
})
export class AccountsettingsComponent implements OnInit {
  successMessage: string;
  errorMessage: string;
  isSubmitting: boolean;
  schoolid: any
  isPrivateSchool: boolean;
  allowRegByUsers: boolean;
  schooInfo: SchoolInformationview = new SchoolInformationview();
  schoolparam: any
  urlparam: any;
  banks: Bank[] = [];
  @ViewChild('bankIdField') bankIdField: NgSelectComponent;

  constructor( private schoolmanagerservice: SchoolmanagementService, private router: Router, private toastr: ToastrService, private activatedrouter: ActivatedRoute, private userservice: UseraccessserviceService, public settings: Settings, private billService : BillingAccountService, private util: UtilService, private paymentservice: PaymentService,public headerinfo: ComponentheaderService) { 
    this.headerinfo.setHeaderDisplay('Account Details', [ {displaytext: 'Account Settings', route: '/account/accountsettings'},{displaytext: 'Account Details', route: '/account/accountdetails'}], [])}

  async ngOnInit() {

      await this.getSchoolInfo()
    if(!this.schooInfo) {
      this.schooInfo = new SchoolInformationview();
    }
    this.banks = await this.paymentservice.getBanks().toPromise();
  }

  async getSchoolInfo() {
    var data: any = await this.schoolmanagerservice.getSchoolDetails().toPromise();
    this.schooInfo = data.schoolInfo;
    
    if(!this.schooInfo.bankId){
      this.bankIdField.clearModel();
    }
  }

  async onSubmit() {  

    let updatedschooldata: any;
      if (this.schooInfo.id > 0){
        try{
          this.isSubmitting=true
        await this.schoolmanagerservice.editSchool(this.schooInfo).toPromise();
        this.toastr.success("School Updated Successfully");}
        catch(err){
          this.toastr.error(err);
          this.isSubmitting=false;

          return;
        }
      }    
      this.isSubmitting=false;

      this.router.navigate(['/account/accountsettings']);
    }

  }

